/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React from 'react';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';

const GridRow = ({ fields, name, setEditMode }) => {
  const editedFields = fields.map((field) => {
    if (field.setGridTitle) {
      return { ...field, name: `${name}.${field.setGridTitle}` };
    }
    return { ...field, name: `${name}.${field.name}` };
  });
  const { renderForm } = useFormApi();

  return (
    <tr className='odd:bg-gray-15'>
      {editedFields.map((field) => {
        return renderForm([
          {
            ...{
              ...field,
              condition: !field.ignoreConditionInGridRow && field.condition
            },
            component: 'grid-cell'
          }
        ]);
      })}
      <td className='w-20 px-4 py-2 text-primary-500'>
        <button className='hover:underline' onClick={() => setEditMode(name)}>
          Manage
        </button>
      </td>
    </tr>
  );
};

export default GridRow;
